import React from 'react'
import { Image, Hotel, Car, Map } from 'lucide-react'
import { colors, borderRadius } from '../../styles/tokens'
import { styles } from '../../styles/newQuotation.styles'
import ImageBlocksSection from './ImageBlocksSection'

/**
 * Modal de cadastro de imagens
 * 
 * Responsabilidade: Permitir cadastro de URLs de imagens para destino e blocos
 */
export default function ImagesModal({
    destination,
    imageUrl1,
    imageUrl2,
    setImageUrl1,
    setImageUrl2,
    existingImages,
    hotelImages,
    carImages,
    tourImages,
    onImageChange,
    onSubmit,
    onBack,
    loading,
    isValid
}) {
    const needsImg1 = !existingImages.img1
    const needsImg2 = !existingImages.img2
    const hotelsList = Object.keys(hotelImages || {})
    const carsList = Object.keys(carImages || {})
    const toursList = Object.keys(tourImages || {})

    return (
        <div style={styles.modalOverlay}>
            <div style={styles.modalContent('700px')}>
                <div style={styles.iconCircle(colors.accent)}>
                    <Image size={32} color={colors.accent} />
                </div>

                <h3 style={{
                    fontSize: '1.25rem',
                    fontWeight: 600,
                    color: colors.primary,
                    marginBottom: '0.5rem',
                    textAlign: 'center'
                }}>
                    Imagens da cotação
                </h3>

                <p style={{
                    fontSize: '0.875rem',
                    color: colors.text.secondary,
                    marginBottom: '1.5rem',
                    textAlign: 'center'
                }}>
                    Cole as URLs das imagens para {destination}
                </p>

                {/* Imagens do Destino */}
                <div style={styles.sectionBox}>
                    <h4 style={styles.sectionTitle}>
                        <Image size={18} />
                        Imagens do Destino
                    </h4>

                    {needsImg1 ? (
                        <div style={{ marginBottom: '1rem' }}>
                            <label style={{
                                display: 'block',
                                fontSize: '0.8125rem',
                                fontWeight: 500,
                                color: colors.text.primary,
                                marginBottom: '0.375rem'
                            }}>
                                Tela 1 - Identidade (apresentação pessoal)
                            </label>
                            <input
                                type="url"
                                value={imageUrl1}
                                onChange={(e) => setImageUrl1(e.target.value)}
                                placeholder="https://..."
                                style={styles.input}
                            />
                            {imageUrl1 && (
                                <div style={styles.previewImage()}>
                                    <img
                                        src={imageUrl1}
                                        alt="Preview 1"
                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                        onError={(e) => { e.target.style.display = 'none' }}
                                    />
                                </div>
                            )}
                        </div>
                    ) : (
                        <div style={{ marginBottom: '1rem' }}>
                            <label style={{
                                display: 'block',
                                fontSize: '0.8125rem',
                                fontWeight: 500,
                                color: colors.text.primary,
                                marginBottom: '0.375rem'
                            }}>
                                Tela 1 - Identidade ✓
                            </label>
                            <div style={{
                                borderRadius: borderRadius.sm,
                                overflow: 'hidden',
                                height: '60px',
                                opacity: 0.7
                            }}>
                                <img
                                    src={existingImages.img1}
                                    alt="Existente 1"
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                />
                            </div>
                            <p style={{ fontSize: '0.75rem', color: colors.accent, margin: '0.25rem 0 0 0' }}>
                                ✓ Já cadastrada
                            </p>
                        </div>
                    )}

                    {needsImg2 ? (
                        <div>
                            <label style={{
                                display: 'block',
                                fontSize: '0.8125rem',
                                fontWeight: 500,
                                color: colors.text.primary,
                                marginBottom: '0.375rem'
                            }}>
                                Tela 2 - Promessa (transformação emocional)
                            </label>
                            <input
                                type="url"
                                value={imageUrl2}
                                onChange={(e) => setImageUrl2(e.target.value)}
                                placeholder="https://..."
                                style={styles.input}
                            />
                            {imageUrl2 && (
                                <div style={styles.previewImage()}>
                                    <img
                                        src={imageUrl2}
                                        alt="Preview 2"
                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                        onError={(e) => { e.target.style.display = 'none' }}
                                    />
                                </div>
                            )}
                        </div>
                    ) : (
                        <div>
                            <label style={{
                                display: 'block',
                                fontSize: '0.8125rem',
                                fontWeight: 500,
                                color: colors.text.primary,
                                marginBottom: '0.375rem'
                            }}>
                                Tela 2 - Promessa ✓
                            </label>
                            <div style={{
                                borderRadius: borderRadius.sm,
                                overflow: 'hidden',
                                height: '60px',
                                opacity: 0.7
                            }}>
                                <img
                                    src={existingImages.img2}
                                    alt="Existente 2"
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                />
                            </div>
                            <p style={{ fontSize: '0.75rem', color: colors.accent, margin: '0.25rem 0 0 0' }}>
                                ✓ Já cadastrada
                            </p>
                        </div>
                    )}
                </div>

                {/* Imagens dos Hotéis - 3 fotos */}
                {hotelsList.length > 0 && (
                    <ImageBlocksSection
                        title="Imagens dos Hotéis"
                        icon={Hotel}
                        items={hotelsList}
                        images={hotelImages}
                        onImageChange={(name, key, value) => onImageChange('hotel', name, key, value)}
                        emoji="🏨"
                        imageCount={3}
                    />
                )}

                {/* Imagens dos Carros - 3 fotos */}
                {carsList.length > 0 && (
                    <ImageBlocksSection
                        title="Imagens dos Carros"
                        icon={Car}
                        items={carsList}
                        images={carImages}
                        onImageChange={(name, key, value) => onImageChange('car', name, key, value)}
                        emoji="🚗"
                        imageCount={3}
                    />
                )}

                {/* Imagens dos Passeios - 1 foto */}
                {toursList.length > 0 && (
                    <ImageBlocksSection
                        title="Imagens dos Passeios"
                        icon={Map}
                        items={toursList}
                        images={tourImages}
                        onImageChange={(name, key, value) => onImageChange('tour', name, key, value)}
                        emoji="🧭"
                        imageCount={1}
                    />
                )}

                {/* Botões */}
                <div style={{ display: 'flex', gap: '1rem', marginTop: '1.5rem' }}>
                    <button
                        onClick={onBack}
                        style={{ ...styles.buttonOutline, flex: 1, justifyContent: 'center' }}
                    >
                        Voltar
                    </button>

                    <button
                        onClick={onSubmit}
                        disabled={loading || !isValid}
                        style={{
                            ...styles.buttonPrimary(isValid),
                            flex: 1
                        }}
                    >
                        {loading ? '⏳ Criando...' : 'Criar cotação'}
                    </button>
                </div>
            </div>
        </div>
    )
}
